// How often a machine's state is asked again (RFC-050, byj-1wv.51.20): by the
// Machines page and an exam's machine on its assignment's page alike.

/** How often the page asks again: often while a machine is on its way. */
export const pollStartingMs = 3_000;
export const pollMs = 30_000;
